var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-avatar",style:({
    height: _vm.size + 'px',
    width: _vm.size + 'px',
    'line-height': _vm.size + 'px',
  })},[_c('div',{staticClass:"value",style:({ 'font-size': _vm.size * 0.4 + 'px' })},[_vm._v(" "+_vm._s(_vm.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }